import { render, staticRenderFns } from "./SwitchDemo.vue?vue&type=template&id=9b106ab4&"
import script from "./SwitchDemo.vue?vue&type=script&lang=js&"
export * from "./SwitchDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports